export default __webpack_public_path__ + "static/media/Result 13.5e727407.pdf";